export const handleBlobChange = ({ blob, index, audioBlob }) => {
	if (index === undefined) {
		audioBlob = [blob];
	} else {
		audioBlob[index] = blob;
	}
	return audioBlob;
};
